import { Leva } from "leva";
// import { useState } from "react";
// import styles from "./SwitchPage.module.css";
// import Tabs from "../../componentsTest/Preview/Tabs";
import { WidgetWrapper } from "../widget/WidgetWrapper";

export const SwitchPage = () => {
    // const [showTestPage, setShowTestPage] = useState(false);

    // // for testing
    // const switchPage = () => {
    //     setShowTestPage(!showTestPage);
    // }

  return (
    <div>
        <Leva collapsed={true} hidden={true}/>
        {/* <button className={styles.switchButton} onClick={switchPage}>{showTestPage ? 'Go to Leora Preview' : 'Go to Leora Test'}</button>
        {showTestPage ? (<Tabs />) : (<WidgetWrapper />)}     */}
        <WidgetWrapper />
    </div>
  )
}